const RemarkType = Object.freeze({
  /** 文字輸入框 */
  TextField: 0,
  /** 日期 picker */
  Date: 1,
  /** 日期 時間 picker */
  DateTime: 2,
  /** 單選 */
  Radio: 3,
  /** 數量 */
  Quantity: 4,
  /** 國碼 電話號碼 */
  MobileNumber: 5,
  /** 多選 */
  Checkbox: 6,
  /** 純文字說明 */
  PureText: 7,
  /** 圖片說明 */
  Picture: 8
})

const RemarkGroupType = Object.freeze({
  /** 訂單備註 */
  Order: 0,
  /** 參加者資料 */
  Attendee: 1
})

export {
  RemarkType,
  RemarkGroupType
}
